<script lang="ts">
  import PDFPage from '../../../../PDFPage.svelte';
  import Image from '../../../../Image.svelte';
  import Signature from '../../../../Signature.svelte';
  import Text from '../../../../Text.svelte';
  import Drawing from '../../../../Drawing.svelte';

  export let pages = [];
  export let pagesScale = [];
  export let allObjects = [];
  export let selectedPageIndex = -1;
  export let previewMode = false;

  export let onMeasure;
  export let selectPage;
  export let updateObject;
  export let deleteObject;
  export let selectFontFamily;
  export let onRightClick;
</script>

<div
  class="sign-pdf-editor w-full"
  data-testid="sign-pdf-editor"
  on:contextmenu|preventDefault={onRightClick}
>
  {#each pages as page, pIndex (page)}
    <div
      class="sign-pdf-editor__page p-5 w-full flex flex-col items-center overflow-hidden relative"
      data-testid="sign-pdf-page"
      on:mousedown={() => selectPage(pIndex)}
      on:touchstart={() => selectPage(pIndex)}
    >
      <div
        class="relative shadow-lg sign-pdf-editor__canvas"
        class:shadow-outline={pIndex === selectedPageIndex}
        data-testid="sign-pdf-canvas"
      >
        <PDFPage
          on:measure={(e) => onMeasure(e.detail.scale, e.detail.image, pIndex)}
          {page}
        />
        <div
          class="absolute top-0 left-0 transform origin-top-left"
          style="transform: scale({pagesScale[pIndex]}); touch-action: none;"
        >
          {#if allObjects[pIndex]}
            {#each allObjects[pIndex] as object (object.id)}
              {#if object.type === 'image'}
                <Image
                  on:update={(e) => updateObject(object.id, e.detail)}
                  on:delete={() => deleteObject(object.id)}
                  file={object.file}
                  payload={object.payload}
                  x={object.x}
                  y={object.y}
                  width={object.width}
                  height={object.height}
                  pageScale={pagesScale[pIndex]}
                />
              {:else if object.type === 'Signature' || object.type === 'quickSign'}
                <Signature
                  on:update={(e) => updateObject(object.id, e.detail)}
                  on:delete={() => deleteObject(object.id)}
                  file={object.file}
                  payload={object.payload}
                  x={object.x}
                  y={object.y}
                  type={object.type}
                  width={object.width}
                  height={object.height}
                  pageScale={pagesScale[pIndex]}
                />
              {:else if object.type === 'text'}
                <Text
                  on:update={(e) => updateObject(object.id, e.detail)}
                  on:delete={() => deleteObject(object.id)}
                  on:selectFont={selectFontFamily}
                  text={object.text}
                  x={object.x}
                  y={object.y}
                  size={object.size}
                  lineHeight={object.lineHeight}
                  fontFamily={object.fontFamily}
                  pageScale={pagesScale[pIndex]}
                  {previewMode}
                />
              {:else if object.type === 'drawing'}
                <Drawing
                  on:update={(e) => updateObject(object.id, e.detail)}
                  on:delete={() => deleteObject(object.id)}
                  path={object.path}
                  x={object.x}
                  y={object.y}
                  width={object.width}
                  originWidth={object.originWidth}
                  originHeight={object.originHeight}
                  pageScale={pagesScale[pIndex]}
                />
              {/if}
            {/each}
          {/if}
        </div>
      </div>
    </div>
  {/each}
</div>

<style>
  /* Desktop/web: hug the canvas so the shadow box has no empty right side */
  .sign-pdf-editor__canvas {
    width: fit-content;
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
  }

  @media (max-width: 767px) {
    .sign-pdf-editor__page {
      padding: 0.75rem 0.5rem !important;
    }

    .sign-pdf-editor__canvas {
      max-width: 100%;
      width: fit-content;
    }

    .sign-pdf-editor__canvas :global(canvas) {
      max-width: 100% !important;
      height: auto !important;
    }
  }
</style>
